import cn from 'classnames';

import { IConDefaultType } from '../../types';

export enum RankingIconVariant {
  UP = 'up',
  DOWN = 'down',
  NORMAL = 'normal',
  ONE = 'one',
  TWO = 'two',
  THREE = 'three',
}
export interface IRankingIconProps extends IConDefaultType {
  variant?: RankingIconVariant;
}

export default function RankingIcon({
  className,
  size = 16,
  rotate,
  flip,
  variant = RankingIconVariant.UP,
}: IRankingIconProps) {
  const style = {
    width: size,
    minWidth: size,
    height: size,
    transform: `rotate(${rotate}deg)`,
  };

  return (
    <i className={cn('dds-icon', className, { flip })} style={style}>
      {variant === RankingIconVariant.UP && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
          <path d="M12 8H9V12H7V8H4L8 4L12 8Z" fill="#F6375A" />
        </svg>
      )}
      {variant === RankingIconVariant.DOWN && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
          <path d="M12 8H9V4H7V8H4L8 12L12 8Z" fill="#229BDC" />
        </svg>
      )}
      {variant === RankingIconVariant.NORMAL && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
          <rect x="4" y="7" width="8" height="2" fill="black" fill-opacity="0.6" />
        </svg>
      )}
      {variant === RankingIconVariant.ONE && (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="22" viewBox="0 0 13 22" fill="none">
          <path
            d="M12.2168 1.12891L12.1377 1.69727L9.4502 21.0684L9.38965 21.5H4.32617L4.40625 20.9307L6.37598 6.82129C6.07045 7.04349 5.76451 7.26511 5.45898 7.4873L5.45996 7.48828C4.85706 7.94762 4.28159 8.36515 3.7334 8.74023L3.28711 9.04492L3.01758 8.57715L1.56641 6.05957L1.3457 5.67578L1.7002 5.41016C2.27639 4.97802 2.86691 4.56042 3.47168 4.15723C4.09288 3.73364 4.65645 3.33856 5.16309 2.97266L5.17383 2.96582C5.71878 2.59296 6.2225 2.26145 6.68457 1.97266C7.12738 1.66792 7.46753 1.42217 7.70898 1.23438L7.84473 1.12891H12.2168Z"
            fill="black"
            stroke="white"
          />
        </svg>
      )}
      {variant === RankingIconVariant.TWO && (
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="22" viewBox="0 0 17 22" fill="none">
          <path
            d="M10.0215 0.787109C11.9872 0.787132 13.5235 1.23626 14.499 2.25293C15.4842 3.27982 15.7896 4.77094 15.5518 6.59961C15.2114 9.34232 13.4935 12.2255 10.5127 15.248L9.89941 15.8545C9.38913 16.3483 8.89122 16.8129 8.4082 17.251C8.97515 17.2284 9.54647 17.203 10.1221 17.1719H10.123C11.2143 17.1144 12.4179 17.0859 13.7334 17.0859H14.3066L14.2285 17.6543L13.7598 21.0674L13.7002 21.499H1.43555L1.50391 20.9385L1.84473 18.123L1.86719 17.9395L2.00391 17.8145C5.01352 15.0604 7.10336 12.8822 8.29688 11.2725C9.40179 9.78083 10.0676 8.46053 10.3359 7.30859C10.4386 6.40901 10.3035 5.84733 10.0508 5.5166C9.80971 5.20136 9.37726 4.9873 8.61328 4.9873C8.20632 4.98731 7.68965 5.05163 7.05566 5.18945L7.0498 5.19043C6.07474 5.3912 5.52265 5.57668 5.29785 5.71973L4.58008 6.17676L4.53027 5.32715C4.47401 4.37075 4.38949 3.45805 4.27734 2.58887L4.2373 2.27734L4.5 2.10547C5.2474 1.61804 6.50383 1.25038 8.18848 0.964844V0.96582C8.78605 0.847299 9.39718 0.787109 10.0215 0.787109Z"
            fill="black"
            stroke="white"
          />
        </svg>
      )}
      {variant === RankingIconVariant.THREE && (
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="23" viewBox="0 0 17 23" fill="none">
          <path
            d="M10.3623 1.4043C12.3821 1.4043 13.9865 1.82637 15.082 2.76074C16.2146 3.7268 16.6057 5.12777 16.3613 6.83887C16.0969 8.68969 15.1564 10.1607 13.5889 11.248C14.2823 11.6147 14.8253 12.1113 15.1914 12.749C15.7041 13.6424 15.8293 14.7432 15.6367 16.0029C15.3664 18.1655 14.455 19.8508 12.875 20.9971L12.873 20.999C11.456 22.0156 9.62307 22.5 7.41895 22.5C5.68945 22.5 4.0229 22.0681 2.4248 21.2139C2.11133 21.0716 1.941 21.0078 1.87891 20.9922L1.27051 20.8398L1.55371 20.2803L3.00488 17.4219L3.2002 17.0381L3.6084 17.1738C3.74942 17.2208 3.93804 17.3288 4.14062 17.4541C4.37482 17.5574 4.65158 17.6641 4.97363 17.7715C5.87102 18.0706 6.69939 18.2148 7.46094 18.2148C8.22299 18.2148 8.85884 18.0264 9.38965 17.667C9.87746 17.3104 10.2091 16.7376 10.3369 15.8691L10.3379 15.8613L10.3398 15.8545C10.4964 14.9668 10.3109 14.5201 10.0127 14.2881L10.002 14.2793C9.62005 13.9649 9.13976 13.796 8.52832 13.7959H5.38867L5.47363 13.2236L5.90039 10.3223L5.96289 9.89453H7.41895C8.18948 9.89451 8.9032 9.79577 9.56348 9.60352C9.64708 9.53588 9.74904 9.46382 9.8584 9.39062C10.0177 9.27683 10.1863 9.12217 10.3633 8.9209C10.7241 8.48737 10.9619 7.9501 11.0635 7.29004C11.1588 6.67035 11.0087 6.3161 10.7305 6.08984C10.3748 5.8009 9.93435 5.64648 9.38086 5.64648C8.77399 5.64651 8.30075 5.68857 7.9502 5.76367L7.9209 5.76953C7.56735 5.82394 7.24503 5.8911 6.95312 5.9707L6.93359 5.97559L6.91504 5.97949C6.31792 6.09323 5.96698 6.19674 5.80762 6.27637L5.16016 6.60059L5.08691 5.87988L4.78809 2.93652L4.75586 2.62305L5.02441 2.45898C5.62279 2.09331 6.51382 1.83952 7.6416 1.66602C8.76069 1.49386 9.67104 1.40433 10.3623 1.4043Z"
            fill="black"
            stroke="white"
          />
        </svg>
      )}
    </i>
  );
}
